// @ts-nocheck
import { Box, IconButton, Tooltip } from '@mui/material';
import { Trash } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import './DeleteButton.css';

const DeleteButton = ({ onClick, size = 20, disabled = false }) => {
  const { t } = useTranslation(['common']);

  return (
    <Box
      className='delete-button'
      onClick={(e) => {
        if (disabled) return;
        e.stopPropagation();
        onClick?.(e);
      }}
      style={{
        opacity: disabled ? 0.4 : undefined,
        pointerEvents: disabled ? 'none' : undefined
      }}
    >
      <Tooltip title={t('delete')}>
        <span>
          <IconButton
            className='delete-button__icon'
            size='small'
            disabled={disabled}
          >
            <Trash size={size} color='#9ca3af' />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

DeleteButton.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.number,
  disabled: PropTypes.bool
};

export default DeleteButton;
